import {Action, Dispatch} from 'redux';
import userManagementAPI from '../APIs/userManagementAPI';
import {CompanyId, Email, InviteUser} from '../../Config/dataModel';

const TYPES = {
    FETCH_ALL_COMPANIES_SUCCESS: 'FETCH_ALL_COMPANIES_SUCCESS',
    FETCH_ALL_USER_INSURERS_SUCCESS: 'FETCH_ALL_USER_INSURERS_SUCCESS',
    FETCH_ALL_USER_SUBAGENTS_SUCCESS: 'FETCH_ALL_USER_SUBAGENTS_SUCCESS',
    FETCH_REG_INSURERS_SUCCESS: 'FETCH_REG_INSURERS_SUCCESS',
    FETCH_REG_SUBAGENTS_SUCCESS: 'FETCH_REG_SUBAGENTS_SUCCESS',
    FETCH_INSURER_HISTORY_SUCCESS: 'FETCH_INSURER_HISTORY_SUCCESS',
    FETCH_SUBAGENT_HISTORY_SUCCESS: 'FETCH_SUBAGENT_HISTORY_SUCCESS',
    MANAGE_USER_SUCCESS: 'MANAGE_USER_SUCCESS',
    FETCH_ALL_NORMAL_USERS_SUCCESS: 'FETCH_ALL_NORMAL_USERS_SUCCESS',
    FETCH_ALL_API_USERS_SUCCESS: 'FETCH_ALL_API_USERS_SUCCESS',
    FETCH_COMPANY_COUNT_SUCCESS: 'FETCH_COMPANY_COUNT_SUCCESS',
    FETCH_NORMAL_USERS_COUNT_SUCCESS: 'FETCH_NORMAL_USERS_COUNT_SUCCESS',
    FETCH_API_USERS_COUNT_SUCCESS: 'FETCH_API_USERS_COUNT_SUCCESS'
};

const fetchAllCompanies = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.allCompanies().then(res => {
            dispatch(storeAllCompanies(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchAllUserInsurers = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.allUserInsurers().then(res => {
            dispatch(storeAllUserInsurers(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchAllUserSubagents = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.allUserSubagents().then(res => {
            dispatch(storeAllUserSubagents(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchRegisteredInsurers = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.registeredInsurers().then(res => {
            dispatch(storeRegisteredInsurers(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchRegisteredSubagents = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.registeredSubagents().then(res => {
            dispatch(storeRegisteredSubagents(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchInsurerHistory = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.insurerHistory().then(res => {
            dispatch(storeInsurerHistory(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchSubagentHistory = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.subagentHistory().then(res => {
            dispatch(storeSubagentHistory(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const addSubagent = (data: CompanyId) => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.addSubagent(data).then(res => {
            dispatch(storeManageStatus(true));
        }).catch(error => {
            throw(error);
        });
    };
};

const deactivateSubagent = (data: CompanyId) => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.deactivateSubagent(data).then(res => {
            dispatch(storeManageStatus(true));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchAllNormalUsers = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.allNormalUsers().then(res => {
            dispatch(storeAllNormalUsers(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchAllApiUsers = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.allApiUsers().then(res => {
            dispatch(storeAllApiUsers(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const inviteUser = (data: InviteUser) => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.inviteUser(data).then(res => {
            dispatch(storeManageStatus(true));
        }).catch(error => {
            throw(error);
        });
    };
};

const enableUser = (data: Email) => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.enableUser(data).then(res => {
            dispatch(storeManageStatus(true));
        }).catch(error => {
            throw(error);
        });
    };
};

const reinviteUser = (data: Email) => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.reinviteUser(data).then(res => {
            dispatch(storeManageStatus(true));
        }).catch(error => {
            throw(error);
        });
    };
};

const recallInvitation = (data: Email) => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.recallInvitation(data).then(res => {
            dispatch(storeManageStatus(true));
        }).catch(error => {
            throw(error);
        });
    };
};

const deactivateUser = (data: Email) => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.deactivateUser(data).then(res => {
            dispatch(storeManageStatus(true));
        }).catch(error => {
            throw(error);
        });
    };
};

const grantAdminRight = (data: Email) => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.grantAdminRight(data).then(res => {
            dispatch(storeManageStatus(true));
        }).catch(error => {
            throw(error);
        });
    };
};

const removeAdminRight = (data: Email) => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.removeAdminRight(data).then(res => {
            dispatch(storeManageStatus(true));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchInsurerCount = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.insurerCount().then(res => {
            dispatch(storeCompanyCount(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchSubagentCount = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.subagentCount().then(res => {
            dispatch(storeCompanyCount(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchNormalUserCount = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.normalUserCount().then(res => {
            dispatch(storeNormalUserCount(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchApiUserCount = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.apiUserCount().then(res => {
            dispatch(storeApiUserCount(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const storeAllCompanies = (data: object) => {
    return {
        type: TYPES.FETCH_ALL_COMPANIES_SUCCESS,
        allCompanies: data
    };
};

const storeAllUserInsurers = (data: object) => {
    return {
        type: TYPES.FETCH_ALL_USER_INSURERS_SUCCESS,
        allUserInsurers: data
    };
};

const storeAllUserSubagents = (data: object) => {
    return {
        type: TYPES.FETCH_ALL_USER_SUBAGENTS_SUCCESS,
        allUserSubagents: data
    };
};

const storeRegisteredInsurers = (data: object) => {
    return {
        type: TYPES.FETCH_REG_INSURERS_SUCCESS,
        registeredInsurers: data
    };
};

const storeRegisteredSubagents = (data: object) => {
    return {
        type: TYPES.FETCH_REG_SUBAGENTS_SUCCESS,
        registeredSubagents: data
    };
};

const storeSubagentHistory = (data: object) => {
    return {
        type: TYPES.FETCH_SUBAGENT_HISTORY_SUCCESS,
        subagentHistory: data
    };
};

const storeInsurerHistory = (data: object) => {
    return {
        type: TYPES.FETCH_INSURER_HISTORY_SUCCESS,
        insurerHistory: data
    };
};

const storeManageStatus = (status: boolean) => {
    return {
        type: TYPES.MANAGE_USER_SUCCESS,
        manageStatus: status
    };
};

const storeAllNormalUsers = (data: object) => {
    return {
        type: TYPES.FETCH_ALL_NORMAL_USERS_SUCCESS,
        allNormalUsers: data
    };
};

const storeAllApiUsers = (data: object) => {
    return {
        type: TYPES.FETCH_ALL_API_USERS_SUCCESS,
        allApiUsers: data
    };
};

const storeCompanyCount = (data: object) => {
    return {
        type: TYPES.FETCH_COMPANY_COUNT_SUCCESS,
        companyCount: data
    };
};

const storeNormalUserCount = (data: object) => {
    return {
        type: TYPES.FETCH_NORMAL_USERS_COUNT_SUCCESS,
        normalUserCount: data
    };
};

const storeApiUserCount = (data: object) => {
    return {
        type: TYPES.FETCH_API_USERS_COUNT_SUCCESS,
        apiUserCount: data
    };
};

export {
    TYPES,
    fetchAllCompanies,
    fetchAllUserInsurers,
    fetchAllUserSubagents,
    fetchRegisteredInsurers,
    fetchRegisteredSubagents,
    fetchInsurerHistory,
    fetchSubagentHistory,
    addSubagent,
    deactivateSubagent,
    fetchAllNormalUsers,
    fetchAllApiUsers,
    inviteUser,
    enableUser,
    reinviteUser,
    recallInvitation,
    deactivateUser,
    grantAdminRight,
    removeAdminRight,
    fetchInsurerCount,
    fetchSubagentCount,
    fetchNormalUserCount,
    fetchApiUserCount
};



// WEBPACK FOOTER //
// ./src/ReduxRequests/Actions/userManagementAction.ts